module.exports = __webpack_public_path__ + "static/media/daftpunktocat-thomas.a171908b.gif";